import { ISvg } from "@interfaces";
export const IconList = (props: ISvg) => (
    <svg
        width={props.size}
        height={props.size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask id="mask0_2648_57095" maskUnits="userSpaceOnUse" x="3" y="2" width="18" height="20">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.00049 2.01172H20.0532V21.8652H3.00049V2.01172Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_2648_57095)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.57359 3.51172C5.91659 3.51172 4.54059 4.85372 4.50159 6.50872V17.2037C4.46459 18.9167 5.81459 20.3277 7.51059 20.3657H15.5746C17.2436 20.2967 18.5656 18.9097 18.5536 17.2097V8.33972L13.9186 3.51172H7.58559H7.57359ZM7.58559 21.8657H7.47659C4.95459 21.8087 2.94659 19.7107 3.00159 17.1877V6.49072C3.05959 4.00972 5.10859 2.01172 7.57159 2.01172H7.58859H14.2386C14.4426 2.01172 14.6376 2.09472 14.7796 2.24172L19.8446 7.51872C19.9786 7.65772 20.0536 7.84472 20.0536 8.03772V17.2037C20.0716 19.7127 18.1176 21.7627 15.6046 21.8647L7.58559 21.8657Z"
                fill={props.color || "#F22F46"}
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2986 8.98431H16.5436C14.7136 8.97931 13.2256 7.48731 13.2256 5.65931V2.75031C13.2256 2.33631 13.5616 2.00031 13.9756 2.00031C14.3896 2.00031 14.7256 2.33631 14.7256 2.75031V5.65931C14.7256 6.66331 15.5426 7.48131 16.5456 7.48431H19.2986C19.7126 7.48431 20.0486 7.82031 20.0486 8.23431C20.0486 8.64831 19.7126 8.98431 19.2986 8.98431Z"
            fill={props.color || "#F22F46"}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7887 16.1084H8.38867C7.97467 16.1084 7.63867 15.7724 7.63867 15.3584C7.63867 14.9444 7.97467 14.6084 8.38867 14.6084H13.7887C14.2027 14.6084 14.5387 14.9444 14.5387 15.3584C14.5387 15.7724 14.2027 16.1084 13.7887 16.1084Z"
            fill={props.color || "#F22F46"}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7442 12.3564H8.38818C7.97418 12.3564 7.63818 12.0204 7.63818 11.6064C7.63818 11.1924 7.97418 10.8564 8.38818 10.8564H11.7442C12.1582 10.8564 12.4942 11.1924 12.4942 11.6064C12.4942 12.0204 12.1582 12.3564 11.7442 12.3564Z"
            fill={props.color || "#F22F46"}
        />
    </svg>
);
